module.exports = {
      id: "icons:location-pin-usage",
      viewBox: "0 0 14 18",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:location-pin-usage",
      toString: function () {
        return this.url;
      }
    }